import Icon from "@components/ui/icon";
import { cn } from "@lib/cn";

interface IProps {
  className?: string;
  isSelected: boolean;
  onClick?: () => void;
}

export const MediaLibFileCheckbox = ({
  isSelected,
  onClick,
  className,
}: IProps) => {
  return (
    <button
      onClick={onClick}
      type="button"
      className={cn(
        "tw-absolute tw-left-1 tw-top-1 tw-z-50 tw-size-6 tw-rounded-md tw-border tw-border-solid tw-shadow-main tw-outline-none tw-transition-opacity group-hover:tw-opacity-100",
        {
          "tw-border-blue-100 tw-bg-white tw-opacity-0 ": !isSelected,
          "tw-border-primary tw-bg-primary tw-opacity-100": isSelected,
        },
        className,
      )}
    >
      <Icon
        icon="ri-check-line"
        className={cn(
          "tw-text-lg/none tw-text-white tw-transition-opacity",
          isSelected ? "tw-opacity-100" : "tw-opacity-0",
        )}
      />
    </button>
  );
};
